import React from "react";

function IconBusiness() {
  return (
    <svg width="22.26" className="icon-business" viewBox="0 0 22.26 18.66">
      <defs>
        <style>{`.cls-1{fill:#f7f8f9;}.cls-2{fill:#828283;}`}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <g id="Inactive_Business-_24px" data-name="Inactive Business- 24px">
            <rect width="21.26" height="14.39" x="0.5" y="3.77" className="cls-1" rx="1"></rect>
            <path
              d="M20.76 4.27a.5.5 0 01.5.5v12.39a.5.5 0 01-.5.5H1.5a.5.5 0 01-.5-.5V4.77a.5.5 0 01.5-.5h19.26m0-1H1.5A1.5 1.5 0 000 4.77v12.39a1.5 1.5 0 001.5 1.5h19.26a1.5 1.5 0 001.5-1.5V4.77a1.5 1.5 0 00-1.5-1.5"
              className="cls-2"
            ></path>
            <path
              d="M13.66 1a1.94 1.94 0 011.94 1.94v1.68a1.94 1.94 0 01-1.94 1.94H7.17a.5.5 0 01-.5-.5V2.94A1.94 1.94 0 018.61 1h5.05m0-1H8.61a2.94 2.94 0 00-2.94 2.94v3.12a1.5 1.5 0 001.5 1.5h6.49a2.94 2.94 0 002.94-2.94V2.94A2.94 2.94 0 0013.66 0"
              className="cls-2"
            ></path>
            <rect width="21.26" height="5.94" x="0.5" y="3.77" className="cls-1" rx="1"></rect>
            <path
              d="M20.76 4.27a.5.5 0 01.5.5v3.94a.5.5 0 01-.5.5H1.5a.5.5 0 01-.5-.5V4.77a.5.5 0 01.5-.5h19.26m0-1H1.5A1.5 1.5 0 000 4.77v3.94a1.5 1.5 0 001.5 1.5h19.26a1.5 1.5 0 001.5-1.5V4.77a1.5 1.5 0 00-1.5-1.5"
              className="cls-2"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default IconBusiness;
